import './styles.scss'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { company } from '../../../../api'

import BusinessManagementRow from './BusinessManagementRow'
import Nixi1Spinner from 'components/Nixi1Spinner'

const businessModelApi = company.commissions

const Index = (props) => {
  const [commissions, setCommissions] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.companies._id) {
      businessModelApi
        .getBusinessModel(undefined, { idCompany: props.companies._id })
        .then(({ data, status }) => {
          if (status === 200) setCommissions(data.results)
        })
        .catch(console.error)
        .finally(() => setLoading(false))
    }
  }, [props.companies._id])

  return (
    <div className='animated fadeIn'>
      <Container className='py-5 company-management credentials-management' fluid>
        <h1>{I18n.t('dashboard_business-model')}</h1>
        {loading ? (
          <Nixi1Spinner width={'25px'} height={'25px'} />
        ) : (
          Object.keys(commissions).map((c) => (
            <div className='section mb-4' key={c}>
              <div className='section-subtitle mb-3'>{I18n.t(`dashboard_credentials-${c}`)}</div>
              <table className='nx-table'>
                <thead>
                  <tr>
                    <th colSpan={2}>{I18n.t('dashboard_provider')}</th>
                  </tr>
                </thead>
                {commissions[c] &&
                  commissions[c].length &&
                  commissions[c].map((provider) => (
                    <BusinessManagementRow
                      key={provider.key}
                      id={provider.key}
                      inactiveRow={
                        <tr>
                          <td>
                            {provider.key === 'api_hitchhiker' ? (
                              <React.Fragment>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_amadeus_international.png`}
                                    alt={I18n.t('dashboard_providers-api_amadeus_international')}
                                    title={I18n.t('dashboard_providers-api_amadeus_international')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_galileo.png`}
                                    alt={I18n.t('dashboard_providers-api_galileo')}
                                    title={I18n.t('dashboard_providers-api_galileo')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img src={`/img/logos/api_sabre.png`} alt={I18n.t('dashboard_providers-api_sabre')} title={I18n.t('dashboard_providers-api_sabre')} />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_farelogix.png`}
                                    alt={I18n.t('dashboard_providers-api_farelogix')}
                                    title={I18n.t('dashboard_providers-api_farelogix')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_mystifly.png`}
                                    alt={I18n.t('dashboard_providers-api_mystifly')}
                                    title={I18n.t('dashboard_providers-api_mystifly')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_sirena.png`}
                                    alt={I18n.t('dashboard_providers-api_sirena')}
                                    title={I18n.t('dashboard_providers-api_sirena')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/api_worldspan.png`}
                                    alt={I18n.t('dashboard_providers-api_worldspan')}
                                    title={I18n.t('dashboard_providers-api_worldspan')}
                                  />
                                </div>
                                <div className='provider-image'>
                                  <img
                                    src={`/img/logos/${provider.key}.png`}
                                    alt={I18n.t(`dashboard_providers-${provider.key}`)}
                                    title={I18n.t(`dashboard_providers-${provider.key}`)}
                                  />
                                </div>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <div className='provider-image'>
                                  <img src={`/img/logos/${provider.key}.png`} alt={provider.key} />
                                </div>
                                <span className='provider-name'>{I18n.t(`dashboard_providers-${provider.key}`)}</span>
                              </React.Fragment>
                            )}
                          </td>
                          <td className='text-right'>
                            <i className='fa fa-pencil' />
                          </td>
                        </tr>
                      }
                    />
                  ))}
              </table>
            </div>
          ))
        )}
      </Container>
    </div>
  )
}

export default connect((state) => ({ companies: state.companies }))(withRouter(Index))
